import {
	GENDER_MEN_HAIR_GROWTH_URL_PARAMETER,
	GENDER_WOMEN_HAIR_GROWTH_URL_PARAMETER,
	HAIR_GROWTH_FILTERING_KEY,
} from "../../../config/site/favy";
import { BaseSegmentedToggle } from "../BaseComponents/BaseSegmentedToggle";
import { useDesktopFilterSelect } from "./FilteringProvider";

const options = [
	{
		value: GENDER_MEN_HAIR_GROWTH_URL_PARAMETER,
		label: "Men",
	},
	{
		value: GENDER_WOMEN_HAIR_GROWTH_URL_PARAMETER,
		label: "Women",
	},
];

export const HairGrowthFilter = () => {
	const { selectedOption, handleChange } = useDesktopFilterSelect(
		HAIR_GROWTH_FILTERING_KEY,
		GENDER_MEN_HAIR_GROWTH_URL_PARAMETER,
	);

	return (
		<div className="tw:mx-auto tw:max-w-[582px] tw:px-4 tw:pb-4 tw:lg:max-w-1170px tw:xl:px-0">
			<div className="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-start tw:rounded-lg tw:bg-white tw:px-6 tw:py-3 tw:shadow-xs tw:md:flex-row tw:lg:py-2">
				<div className="tw:flex tw:items-center">
					<img
						src="/react-images/favy/genderIcon.svg"
						className="tw:mr-3 tw:h-8 tw:w-8"
						alt="Gender Icon"
					/>
					<p className="tw:text-base tw:font-semibold tw:text-black">
						Select Your Gender
					</p>
				</div>
				<BaseSegmentedToggle
					options={options}
					selected={selectedOption}
					onChange={(value) => handleChange({ target: { value } })}
					styles={baseSegmentedToggleStyles}
					aria-label="Gender"
				/>
			</div>
		</div>
	);
};

const baseSegmentedToggleStyles = {
	radioGroup:
		"tw:flex tw:items-center tw:justify-center tw:rounded-full tw:bg-[#F0F0F0] tw:ml-0 tw:mt-2 tw:md:mt-0 tw:md:ml-3 tw:py-2 tw:px-1",
	radio:
		"tw:text-xs tw:md:text-sm tw:font-semibold tw:w-[90px] tw:py-1 tw:md:py-2 tw:px-1 tw:mx-1 tw:rounded-full tw:bg-transparent tw:border-0 tw:hover:cursor-pointer tw:text-center",
	default:
		"tw:bg-transparent tw:text-black tw:md:text-gray-600 tw:md:hover:text-black tw:md:hover:bg-white",
	selected: "tw:bg-white tw:text-[#e1255b]!",
};
